import { render, staticRenderFns } from "./BorderForm.vue?vue&type=template&id=248c97a9&lang=pug"
import script from "./BorderForm.vue?vue&type=script&lang=js"
export * from "./BorderForm.vue?vue&type=script&lang=js"
import style0 from "./BorderForm.vue?vue&type=style&index=0&id=248c97a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports